// Font Style Plugin
export default {
    id: 'font',
    label: 'Font',
    icon: 'Type',
    properties: {
        fontFamily: {
            label: 'Family',
            type: 'select',
            options: ['sans', 'serif', 'mono'],
            default: 'sans',
            toClass: (value) => value ? `font-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^font-(sans|serif|mono)$/);
                return match ? match[1] : null;
            }
        },
        fontSize: {
            label: 'Size',
            type: 'select',
            options: ['xs', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', '8xl', '9xl'],
            default: 'base',
            toClass: (value) => value ? `text-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^text-(xs|sm|base|lg|xl|2xl|3xl|4xl|5xl|6xl|7xl|8xl|9xl)$/);
                return match ? match[1] : null;
            }
        },
        fontSmoothing: {
            label: 'Smoothing',
            type: 'select',
            options: ['antialiased', 'subpixel-antialiased'],
            default: 'antialiased',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['antialiased', 'subpixel-antialiased'].includes(className)) {
                    return className;
                }
                return null;
            }
        },
        fontStyle: {
            label: 'Style',
            type: 'toggle',
            options: [
                { label: 'Italic', value: 'italic', off: 'not-italic' }
            ],
            default: 'not-italic',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['italic', 'not-italic'].includes(className)) {
                    return className;
                }
                return null;
            }
        },
        fontWeight: {
            label: 'Weight',
            type: 'select',
            options: ['thin', 'extralight', 'light', 'normal', 'medium', 'semibold', 'bold', 'extrabold', 'black'],
            default: 'normal',
            toClass: (value) => value ? `font-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^font-(thin|extralight|light|normal|medium|semibold|bold|extrabold|black)$/);
                return match ? match[1] : null;
            }
        },
        letterSpacing: {
            label: 'Letter Spacing',
            type: 'select',
            options: ['tighter', 'tight', 'normal', 'wide', 'wider', 'widest'],
            default: 'normal',
            toClass: (value) => value ? `tracking-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^tracking-(.+)$/);
                return match ? match[1] : null;
            }
        },
        lineHeight: {
            label: 'Line Height',
            type: 'select',
            options: ['none', 'tight', 'snug', 'normal', 'relaxed', 'loose', '3', '4', '5', '6', '7', '8', '9', '10'],
            default: 'normal',
            toClass: (value) => value ? `leading-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^leading-(.+)$/);
                return match ? match[1] : null;
            }
        }
    }
};
